
import login from "components/Login/Login";
import Register from "components/Login/Register";
import Driver from "views/driver/Driver";
import ManageDriver from "views/driver/ManageDriver";
import ManageOrder from "views/orders/ManageOrder";
import Orders from "views/orders/Orders";
import ManageTrip from "views/trip/ManageTrip";
import TripOrder from "views/trip/TripOrder";
import Trip from "views/trip/Trips";
import Dashboard from 'views/dashboard/Dashboard'
import StoreMaster from 'views/storemaster/StoreMaster'
import ManageStore from 'views/storemaster/ManageStore'
var dashRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "design_app",
    component: Dashboard,
    layout: "/admin",
    display: true
  },
  // view store
  {
    path: "/store-master",
    name: "StoreMaster",
    icon: "shopping_box",
    component: StoreMaster,
    layout: "/admin",
    display: true,
    RoleId: 3
  },
  // edit store
  {
    path: "/manage-store/:id",
    name: "StoreMaster",
    icon: "shopping_box",
    component: ManageStore,
    layout: "/admin",
    display: false
  },
  // add store
  {
    path: "/manage-store",
    name: "StoreMaster",
    icon: "shopping_box",
    component: ManageStore,
    layout: "/admin",
    display: false
  },

  {
    path: "/driver",
    name: "Driver",
    icon: "users_single-02",
    component: Driver,
    layout: "/admin",
    display: true
  },
  {
    path: "/manage-driver/:id",
    name: "Driver",
    icon: "design_app",
    component: ManageDriver,
    layout: "/admin",
    display: false
  },
  {
    path: "/manage-driver",
    name: "Driver",
    icon: "design_app",
    component: ManageDriver,
    layout: "/admin",
    display: false
  },
  {
    path: "/order",
    name: "Orders",
    icon: "files_paper",
    component: Orders,
    layout: "/admin",
    display: true
  },
  {
    path: "/manage-order/:id",
    name: "Orders",
    icon: "files_paper",
    component: ManageOrder,
    layout: "/admin",
    display: false
  },
  {
    path: "/manage-order",
    name: "Orders",
    icon: "files_paper",
    component: ManageOrder,
    layout: "/admin",
    display: false
  },
  {
    path: "/trip",
    name: "Trip",
    icon: "shopping_shop",
    component: Trip,
    layout: "/admin",
    display: true
  },
  {
    path: "/manage-trip/:id",
    name: "Trip",
    icon: "shopping_shop",
    component: ManageTrip,
    layout: "/admin",
    display: false
  },
  {
    path: "/manage-trip",
    name: "Trip",
    icon: "shopping_shop",
    component: ManageTrip,
    layout: "/admin",
    display: false
  },
  {
    path: "/trip-order/:id",
    name: "Trip",
    icon: "shopping_shop",
    component: TripOrder,
    layout: "/admin",
    display: false
  },
  {
    path: "/login",
    name: "Login",
    icon: "shopping_shop",
    component: login,
    layout: "/",
    display: false
  },
  {
    path: "/register",
    name: "Register",
    icon: "shopping_shop",
    component: Register,
    layout: "/",
    display: false
  }

];
export default dashRoutes;

